import {GitPullRequestDraftIcon} from '@primer/octicons-react'

import {usePullRequestState} from '../../../../hooks/use-pull-request-state'
import {useLayoutQuery} from '../../../../page-data/loaders/use-layout-query'
import {PullRequestState} from '../../../../types'
import {OverviewReadyForReviewControl} from '../mergeability/shared/OverviewReadyForReviewControl'
import {OverviewUpdateBranchControl} from '../mergeability/shared/OverviewUpdateBranchControl'
import {isForYouRefreshEnabled} from '../shared/for-you-feature-flags'
import {ForYouItem} from '../shared/ForYouItem'
import {useForYouActionErrors} from '../shared/use-for-you-action-errors'

export function shouldShowDraftPR(pullRequestState: PullRequestState) {
  return pullRequestState === PullRequestState.Draft
}

export function DraftPR() {
  const {onUpdateBranchError, footer} = useForYouActionErrors()
  const pullRequestState = usePullRequestState()
  const {user} = useLayoutQuery().data

  if (!shouldShowDraftPR(pullRequestState)) {
    return null
  }

  const canMarkReadyForReview = !!user?.canMarkReadyForReview

  if (!canMarkReadyForReview) {
    return (
      <ForYouItem
        itemId="draft-pr"
        footer={footer}
        visual={{kind: 'icon', icon: GitPullRequestDraftIcon, tone: 'neutral', glyphSize: 12}}
        title="Draft"
        subText="This pull request is not ready for review yet."
        actions={[
          {
            id: 'update-branch',
            content: isForYouRefreshEnabled() ? (
              <OverviewUpdateBranchControl itemName="draft-pr" onError={onUpdateBranchError} />
            ) : null,
          },
        ]}
      />
    )
  }

  return (
    <ForYouItem
      itemId="draft-pr"
      footer={footer}
      visual={{kind: 'icon', icon: GitPullRequestDraftIcon, tone: 'neutral', glyphSize: 12}}
      title="Draft"
      subText="Mark this pull request as ready when you want reviews."
      actions={[
        {
          id: 'update-branch',
          content: isForYouRefreshEnabled() ? (
            <OverviewUpdateBranchControl itemName="draft-pr" onError={onUpdateBranchError} />
          ) : null,
        },
        {
          id: 'ready-for-review',
          content: <OverviewReadyForReviewControl itemName="draft-pr" />,
        },
      ]}
    />
  )
}
